





































































































































































































import { Component} from 'vue-property-decorator';
import LegendUI from "@/components/map/LegendUI.vue";
import MapUI from "@/components/map/MapUI.vue";
import Print from "./print.class";
import Map from "@/components/map/Map";
import { MAP_LAYERS } from "./data/farmland";

@Component({
  components: {
    'ol-map': MapUI,
    'v-legend': LegendUI
  }
})
export default class PrintLandMap extends Print {
  onMapCreated(map:Map) {
    this.$map = map;
    /*
     * replace wfs layers.
     * cache layers lost all functions, so we need to re-create them
     * */
    for (let i=0; i<this.mapLayers.length; i++) {
      if (this.mapLayers[i].title=='mlFarmland') {
        if (this.isDoae) {
          this.mapLayers[i] = MAP_LAYERS[0];
        } else {
          this.mapLayers[i] = MAP_LAYERS[1];
        }
        break;
      }
    }
    if (this.mapFilter) {
      let filter = this.createFilter();
      this.applyFilterToLayer(filter, this.mapLayers);
      //if (this.mapFilter.ProvinceCode) {
      //  this.zoomToTambon();
      //} else {
        this.adjustScale();
      //}
    } else {
      this.adjustScale();
    }
    this.$map.createOverlayLayersAndControls(this.mapLayers);
  }
}
